import { createIcon } from "@chakra-ui/react";

export const User = createIcon({
  displayName: "User",
  viewBox: "0 0 24 24",
  d: "M14.571 14.25h-4.437C5.642 14.25 2 17.944 2 22.5c0 .828.662 1.5 1.479 1.5h17.748a1.49 1.49 0 0 0 1.479-1.5c0-4.556-3.642-8.25-8.135-8.25zm-10.307 7.5c.365-2.958 2.857-5.25 5.87-5.25h4.437c3.012 0 5.505 2.294 5.87 5.25H4.264zM12.353 12c3.267 0 5.916-2.686 5.916-6s-2.649-6-5.916-6C9.086 0 6.437 2.686 6.437 6s2.648 6 5.916 6zm0-9.75c2.039 0 3.697 1.682 3.697 3.75s-1.658 3.75-3.697 3.75S8.655 8.067 8.655 6c0-2.068 1.66-3.75 3.698-3.75z",
  defaultProps: {
    "aria-label": "A human, head and torso, symbol"
  }
});

export default User;
